import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ImpressumPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Add noindex meta tag
  useEffect(() => {
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex, nofollow';
    document.head.appendChild(metaRobots);

    return () => {
      document.head.removeChild(metaRobots);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-lg' : 'bg-[#2F4858]'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <div className="flex items-center">
              <Link to="/" className="cursor-pointer">
                <img
                  src="https://static.readdy.ai/image/535cd5cb202604744f94f7b2225e7be8/507ad711238d1ff66498f69658d73c1b.png"
                  alt="HOMMEN Consulting Logo"
                  className="h-12 w-auto"
                />
              </Link>
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <Link
                to="/"
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-[#2F4858] hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'
                }`}
              >
                Startseite
              </Link>
              <Link
                to="/#services"
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-[#2F4858] hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'
                }`}
              >
                Leistungen
              </Link>
              <Link
                to="/#contact"
                className="px-6 py-2.5 bg-[#FF6B35] text-white text-sm font-medium rounded-full hover:bg-[#e55a2a] transition-colors whitespace-nowrap cursor-pointer"
              >
                Kontakt
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Header */}
      <section className="pt-32 pb-16 bg-gradient-to-b from-[#2F4858] to-[#3a5a6e]">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Impressum</h1>
          <p className="text-white/80 text-lg">Angaben gemäß § 5 TMG</p>
        </div>
      </section>

      {/* Content */}
      <main className="py-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="space-y-12">
            {/* Company Info */}
            <article className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#2F4858]">
                  <i className="ri-building-2-line text-2xl text-white"></i>
                </div>
                <h2 className="text-2xl font-bold text-[#2F4858] ml-4">Unternehmensangaben</h2>
              </div>
              <div className="text-gray-700 leading-relaxed space-y-2 text-[15px]">
                <p className="font-semibold text-[#2F4858]">Hommen Consulting GmbH</p>
                <p>Westring 32</p>
                <p>41379 Brüggen</p>
                <p>Deutschland</p>
              </div>
            </article>

            {/* Representation */}
            <article className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#2F4858]">
                  <i className="ri-user-star-line text-2xl text-white"></i>
                </div>
                <h2 className="text-2xl font-bold text-[#2F4858] ml-4">Vertretungsberechtigt</h2>
              </div>
              <div className="text-gray-700 leading-relaxed text-[15px]">
                <p>Geschäftsführer: Sven Firnrohr</p>
              </div>
            </article>

            {/* Contact */}
            <article className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#2F4858]">
                  <i className="ri-contacts-line text-2xl text-white"></i>
                </div>
                <h2 className="text-2xl font-bold text-[#2F4858] ml-4">Kontakt</h2>
              </div>
              <div className="text-gray-700 leading-relaxed space-y-2 text-[15px]">
                <p>
                  <span className="font-medium text-[#2F4858]">Telefon:</span>{' '}
                  <a href="tel:+4917631669010" className="hover:text-[#FF6B35] transition-colors cursor-pointer">
                    +49 (176) 316 69 010
                  </a>
                </p>
                <p>
                  <span className="font-medium text-[#2F4858]">E-Mail:</span>{' '}
                  <a href="mailto:service@hommen-consulting.de" className="hover:text-[#FF6B35] transition-colors cursor-pointer">
                    service@hommen-consulting.de
                  </a>
                </p>
              </div>
            </article>

            {/* Registration */}
            <article className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#2F4858]">
                  <i className="ri-file-text-line text-2xl text-white"></i>
                </div>
                <h2 className="text-2xl font-bold text-[#2F4858] ml-4">Registereintrag</h2>
              </div>
              <div className="text-gray-700 leading-relaxed space-y-2 text-[15px]">
                <p>
                  <span className="font-medium text-[#2F4858]">Registergericht:</span> Amtsgericht Krefeld
                </p>
                <p>
                  <span className="font-medium text-[#2F4858]">Registernummer:</span> HRB 19012
                </p>
              </div>
            </article>

            {/* Tax ID */}
            <article className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#2F4858]">
                  <i className="ri-money-euro-circle-line text-2xl text-white"></i>
                </div>
                <h2 className="text-2xl font-bold text-[#2F4858] ml-4">Umsatzsteuer-ID</h2>
              </div>
              <div className="text-gray-700 leading-relaxed text-[15px]">
                <p>
                  Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:
                </p>
                <p className="mt-2 font-medium text-[#2F4858]">DE353217796</p>
              </div>
            </article>

            {/* Liability for Content */}
            <article className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#FF6B35]">
                  <i className="ri-information-line text-2xl text-white"></i>
                </div>
                <h2 className="text-2xl font-bold text-[#2F4858] ml-4">Haftung für Inhalte</h2>
              </div>
              <div className="text-gray-700 leading-relaxed space-y-4 text-[15px]">
                <p>
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                </p>
                <p>
                  Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                </p>
              </div>
            </article>

            {/* Liability for Links */}
            <article className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#FF6B35]">
                  <i className="ri-links-line text-2xl text-white"></i>
                </div>
                <h2 className="text-2xl font-bold text-[#2F4858] ml-4">Haftung für Links</h2>
              </div>
              <div className="text-gray-700 leading-relaxed space-y-4 text-[15px]">
                <p>
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                </p>
                <p>
                  Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                </p>
              </div>
            </article>

            {/* Copyright */}
            <article className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#FF6B35]">
                  <i className="ri-copyright-line text-2xl text-white"></i>
                </div>
                <h2 className="text-2xl font-bold text-[#2F4858] ml-4">Urheberrecht</h2>
              </div>
              <div className="text-gray-700 leading-relaxed space-y-4 text-[15px]">
                <p>
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                </p>
                <p>
                  Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis.
                </p>
              </div>
            </article>
          </div>

          {/* Back to Home */}
          <div className="mt-16 text-center">
            <Link
              to="/"
              className="inline-flex items-center px-8 py-4 bg-[#2F4858] text-white font-semibold rounded-full hover:bg-[#3a5a6e] transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line mr-2 text-lg"></i>
              Zurück zur Startseite
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#f5f0eb] py-12">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-600">
            <p>© 2025 HOMMEN Consulting GmbH. Alle Rechte vorbehalten.</p>
            <div className="mt-4 md:mt-0 flex items-center space-x-6">
              <Link to="/datenschutz" className="hover:text-[#FF6B35] transition-colors cursor-pointer">
                Datenschutz
              </Link>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="hover:text-[#FF6B35] transition-colors cursor-pointer"
              >
                Web Design
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
